import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/lib/Button';

import t from '../../lib/I18n';
import config from "../../config";
import TrackingActions from "../../actions/TrackingActions";

import ModalTabs from '../general/ModalTabs';
import Icon from '../general/Icon';

class LoginModalHeader extends React.PureComponent {
    static propTypes = {
        closeModal: PropTypes.func,
        onClose: PropTypes.func,
        hideClose: PropTypes.bool,
        handleRegister: PropTypes.func,
    };

    handleRegisterTab = () => {
        const { handleRegister, onClose } = this.props;
        const externalRegistrationLink = config.get('externalRegistrationLink');

        if (externalRegistrationLink) {
            TrackingActions.externalLink({ name: 'register' });
            window.open(externalRegistrationLink);
        } else {
            onClose();
            handleRegister();
        }
    };

    render() {
        return (
            <React.Fragment>
                <ModalTabs activeTab="login">
                    <ModalTabs.Tab name="register" onClick={ this.handleRegisterTab } title={ t('account.register') } />
                    <ModalTabs.Tab name="login" title={ t('account.login') } />
                </ModalTabs>
                { !this.props.hideClose && (
                    <div className="modal__header__wrapper">
                        <div className="modal__header__right modal__header__right--login">
                            <Button className="btn btn-link modal-header__close-button" onClick={this.props.closeModal}>
                                <Icon icon="close" srOnly={t('button.text.close')} />
                            </Button>
                        </div>
                    </div>
                ) }
            </React.Fragment>
        );
    }
}

export default LoginModalHeader;
